["EUR", "USD", "GBP"]
